import React from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  &.flex-grow {
    flex-grow: 1;
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  &.padding-05 {
    padding: 0 0.5rem;
  }
`;

type Props = {
  button: React.ReactNode;
  onClick: (e: React.MouseEvent<any>) => void;
  disabled?: boolean;
  flexGrow?: boolean;
  className?: string;
  shouldPreventBubble?: boolean; // 이벤트버블링 방지 여부
};

const ClickableContainer = ({ button, onClick, disabled = false, flexGrow = false, className = '', shouldPreventBubble = false }: Props) => {
  const size = useOutletContext<any>();
  return (
    <Root
      className={`${disabled ? 'disabled' : ''} ${flexGrow ? 'flex-grow' : ''} ${className}`}
      role='button'
      tabIndex={0}
      onClick={(e) => {
        if ((size?.innerSize.W ?? window.innerWidth) <= 1024 && shouldPreventBubble) e.stopPropagation();
        onClick(e);
      }}
    >
      {button}
    </Root>
  );
};

export default ClickableContainer;
